import Popup from 'reactjs-popup';
import styled from 'styled-components';

export const SettingsPopup = styled(Popup)`
  &-content {
    max-width: 600px;
    border-radius: 4px;
    margin-top: 100px !important;
		width:90%;
		max-height: 500px;
		min-height: 300px;
		height: auto;
		background: var(--modalBgColor);
		border-color: var(--modalBorderColor);
  }
`;

export const ModalContainer = styled.div`
	display: flex;
	flex-direction: column;
	padding: 12px 16px;
	height: 100%;

	&.confirmation-modal{
		padding:1rem 1rem .5rem;
	}
`;

export const ModalHeader = styled.h4`
	color: var(--textColor);
	align-self: flex-start;
  margin-top: 0px;
  padding: 2px 0px;
	margin-bottom:6px;
	font-size: 1.25rem;
	flex-shrink: 0;

	&.confirmation-modal-head{
	font-size: 1.05rem;
	margin-bottom: 8px;
	color: var(--textColor);
	}
`;
export const ModalContent = styled.div`
	font-family: Inter;
	font-size: 0.95rem;
	line-height: 1.42;
	display: flex;
  flex-direction: column;
	border-top: 1px solid var(--borderColor);
  gap: 7px;
  padding: 0px 0px 10px;
	color: var(--textColor);
	// align-items: center;
  // justify-content: center;
	flex: 1;
  overflow-y: auto;
	min-height:200px;

`;

export const ModalFooter = styled.div`
	display: flex;
	align-self: flex-end;
	justify-content: flex-end;
  margin-top: 10px;
	bottom: 2px;
	flex-direction: row;
	gap: 15px;
	padding-bottom: 2px;
	padding-right: 0px;
	width: 100%;
	flex-shrink: 0;;
	@media (max-width:440px){
		gap:8px;
	}
	button{
			border: 1px solid var(--btnBgNo);
			padding: 10px 22px;
			border-radius: 3px;
	}
			&.confirmation-modal-footer{
				justify-content: center;
				padding-right: 0;
				margin-top:20px;
			}
`;